// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Categories.css */

/* Categories.css */

.grid-container {
    display: flex !important;
    flex-wrap: wrap !important;
    gap: 24px !important;
    width: 100% !important;
    /* Supprime le padding ici s'il est déjà sur le parent React */
    padding: 0 !important; 
    box-sizing: border-box !important;
}

.category-card {
    background-color: #2B303B !important;
    border-radius: 24px !important;
    padding: 20px !important;
    color: white !important;
    
    /* Utilise min-width au lieu de width fixe pour plus de souplesse */
    min-width: 240px !important; 
    flex: 1 1 240px !important; /* Permet de grandir un peu si besoin */
    max-width: 320px !important; /* Évite que la carte devienne géante sur grand écran */
    height: 280px !important;
    
    display: flex !important;
    flex-direction: column !important;
    justify-content: space-between !important;
    box-shadow: 0px 10px 25px rgba(0, 0, 0, 0.2) !important;
}

.category-card:hover {
    transform: translateY(-8px);
    box-shadow: 0px 20px 40px rgba(0, 0, 0, 0.4) !important;
}

.category-title-fix {
    font-weight: 700 !important;
    font-size: 18px !important; /* Taille de police réduite */
    margin-top: 15px !important;
    line-height: 1.2 !important;
    
    /* COUPE LE TEXTE SI TROP LONG (Garantit l'alignement) */
    display: -webkit-box;
    -webkit-line-clamp: 2; 
    -webkit-box-orient: vertical;
    overflow: hidden;
    height: 2.4em; /* Garde l'espace pour 2 lignes */
}

.icon-box {
    background-color: rgba(67, 24, 255, 0.2);
    border-radius: 12px;
    padding: 10px;
    display: inline-flex;
}

.card-footer-text {
    font-size: 13px !important;
    opacity: 0.8;
}`, "",{"version":3,"sources":["webpack://./src/pages/Categories/Categories.css"],"names":[],"mappings":"AAAA,mBAAmB;;AAEnB,mBAAmB;;AAEnB;IACI,wBAAwB;IACxB,0BAA0B;IAC1B,oBAAoB;IACpB,sBAAsB;IACtB,8DAA8D;IAC9D,qBAAqB;IACrB,iCAAiC;AACrC;;AAEA;IACI,oCAAoC;IACpC,8BAA8B;IAC9B,wBAAwB;IACxB,uBAAuB;;IAEvB,mEAAmE;IACnE,2BAA2B;IAC3B,0BAA0B,EAAE,uCAAuC;IACnE,2BAA2B,EAAE,uDAAuD;IACpF,wBAAwB;;IAExB,wBAAwB;IACxB,iCAAiC;IACjC,yCAAyC;IACzC,uDAAuD;AAC3D;;AAEA;IACI,2BAA2B;IAC3B,uDAAuD;AAC3D;;AAEA;IACI,2BAA2B;IAC3B,0BAA0B,EAAE,6BAA6B;IACzD,2BAA2B;IAC3B,2BAA2B;;IAE3B,wDAAwD;IACxD,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;IAChB,aAAa,EAAE,iCAAiC;AACpD;;AAEA;IACI,wCAAwC;IACxC,mBAAmB;IACnB,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,0BAA0B;IAC1B,YAAY;AAChB","sourcesContent":["/* Categories.css */\n\n/* Categories.css */\n\n.grid-container {\n    display: flex !important;\n    flex-wrap: wrap !important;\n    gap: 24px !important;\n    width: 100% !important;\n    /* Supprime le padding ici s'il est déjà sur le parent React */\n    padding: 0 !important; \n    box-sizing: border-box !important;\n}\n\n.category-card {\n    background-color: #2B303B !important;\n    border-radius: 24px !important;\n    padding: 20px !important;\n    color: white !important;\n    \n    /* Utilise min-width au lieu de width fixe pour plus de souplesse */\n    min-width: 240px !important; \n    flex: 1 1 240px !important; /* Permet de grandir un peu si besoin */\n    max-width: 320px !important; /* Évite que la carte devienne géante sur grand écran */\n    height: 280px !important;\n    \n    display: flex !important;\n    flex-direction: column !important;\n    justify-content: space-between !important;\n    box-shadow: 0px 10px 25px rgba(0, 0, 0, 0.2) !important;\n}\n\n.category-card:hover {\n    transform: translateY(-8px);\n    box-shadow: 0px 20px 40px rgba(0, 0, 0, 0.4) !important;\n}\n\n.category-title-fix {\n    font-weight: 700 !important;\n    font-size: 18px !important; /* Taille de police réduite */\n    margin-top: 15px !important;\n    line-height: 1.2 !important;\n    \n    /* COUPE LE TEXTE SI TROP LONG (Garantit l'alignement) */\n    display: -webkit-box;\n    -webkit-line-clamp: 2; \n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    height: 2.4em; /* Garde l'espace pour 2 lignes */\n}\n\n.icon-box {\n    background-color: rgba(67, 24, 255, 0.2);\n    border-radius: 12px;\n    padding: 10px;\n    display: inline-flex;\n}\n\n.card-footer-text {\n    font-size: 13px !important;\n    opacity: 0.8;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
